const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    PHY_LOCATION_APIGATEWAY_URL: 'https://zn51277ox9.execute-api.eu-west-1.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://peu97yvnb8.execute-api.eu-west-1.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://emgzqi0v31.execute-api.eu-west-1.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.eu.forwood.one'
  },
  configurationService: {
    URL: 'https://config.eu.forwood.one',
    WEBSOCKET: 'wss://njlct11lni.execute-api.eu-west-1.amazonaws.com/prod'
  },
};

export default config;